import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 text-xl font-heading font-semibold text-white mb-4">
              <span className="text-primary-400">CSSBuy</span>
              <span>Spreadsheet</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {t('disclaimer_text')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">{t('categories')}</h4>
            <div className="space-y-2.5">
              {['shoes', 'hoodies_sweaters', 't_shirts', 'jackets', 'pants_shorts'].map((key) => (
                <a
                  key={key}
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                >
                  {t(key)}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">{t('guides')}</h4>
            <div className="space-y-2.5">
              <button onClick={() => navigate('/cssbuy-spreadsheet')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                CSSBuy Spreadsheet
              </button>
              <button onClick={() => navigate('/cssbuy-review')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                CSSBuy Review
              </button>
              <button onClick={() => navigate('/cssbuy-shipping-guide')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('shipping_cost')}
              </button>
              <button onClick={() => navigate('/cssbuy-qc')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('qc_guide')}
              </button>
              <button onClick={() => navigate('/cssbuy-warehouse')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('warehouse')}
              </button>
              <button onClick={() => navigate('/cssbuy-alternatives')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('comparison')}
              </button>
              <button onClick={() => navigate('/cssbuy-safety-guide')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('safety')}
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">{t('footer_about')}</h4>
            <div className="space-y-2.5">
              <button onClick={() => navigate('/about')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('footer_about')}
              </button>
              <button onClick={() => navigate('/contact')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('footer_contact')}
              </button>
              <button onClick={() => navigate('/disclaimer')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('footer_disclaimer')}
              </button>
              <button onClick={() => navigate('/privacy')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('footer_privacy')}
              </button>
              <button onClick={() => navigate('/terms')} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors text-left">
                {t('footer_terms')}
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {new Date().getFullYear()} CSSBuy Spreadsheet. {t('footer_rights')}
          </p>
          <p className="text-xs text-foreground-500">
            cssbuybr.my — Independent Resource
          </p>
        </div>
      </div>
    </footer>
  );
}